// @flow

import { RemoveButton } from '@gandi/cart';

import styles from './RemoveButton.scss';

type Props = {
  /** action to set / unset confirmation step  */
  fireConfirmationStep: boolean => void,
};

export default function RemoveButtonFF({
  fireConfirmationStep,
}: Props): React.MixedElement {
  return (
    <RemoveButton
      className={styles.root}
      handleRemoveAction={() => fireConfirmationStep(true)}
    />
  );
}
